// color 작성
export const Color = {
  mainColor: '#fee365',
  lineBorder: '0.5px solid rgba(0, 0, 0, 0.5)',
};
